import { render } from "./ExamPreparation.vue?vue&type=template&id=fcb079e6"
import script from "./ExamPreparation.vue?vue&type=script&lang=js"
export * from "./ExamPreparation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__